(function () {
  function closeTooltip(tooltip, info) {
    tooltip.hidden = true;
    info.setAttribute('aria-expanded', 'false');
  }

  function positionTooltip(tooltip, anchor) {
    var rect = anchor.getBoundingClientRect();
    var isRTL = document.documentElement.dir === 'rtl';

    tooltip.style.top = rect.bottom + 8 + 'px';
    tooltip.style.left = '';
    tooltip.style.right = '';

    if (isRTL) {
      tooltip.style.right = Math.max(8, window.innerWidth - rect.right) + 'px';
    } else {
      tooltip.style.left = Math.max(8, rect.left) + 'px';
    }

    // Keep it on-screen if that placement pushes it past the far edge.
    var tooltipRect = tooltip.getBoundingClientRect();
    if (tooltipRect.right > window.innerWidth - 8) {
      tooltip.style.left = '';
      tooltip.style.right = '8px';
    } else if (tooltipRect.left < 8) {
      tooltip.style.right = '';
      tooltip.style.left = '8px';
    }
  }

  function ensureNote(priceEl) {
    var next = priceEl.nextElementSibling;
    if (next && next.classList && next.classList.contains('aviiro-shipping-note')) return;

    var strings = window.aviiroStrings || {};
    var infoId = 'aviiro-shipping-info-' + Math.random().toString(36).slice(2, 8);

    var wrap = document.createElement('div');
    wrap.className = 'aviiro-shipping-note';

    var label = document.createElement('span');
    label.className = 'aviiro-shipping-note__label';
    label.textContent = '🚚 ' + (strings.freeShipping || 'Free shipping');
    wrap.appendChild(label);

    var info = document.createElement('button');
    info.type = 'button';
    info.className = 'aviiro-shipping-note__info';
    info.setAttribute('aria-expanded', 'false');
    info.setAttribute('aria-controls', infoId);
    info.setAttribute('aria-label', strings.freeShippingInfoLabel || 'Shipping information');
    info.textContent = 'i';
    wrap.appendChild(info);

    // Appended to <body> (not inside wrap) and position: fixed, so it can't
    // get clipped by the price card's `overflow: hidden` (needed for the
    // star-shower effect) the way an absolutely-positioned descendant would.
    var tooltip = document.createElement('div');
    tooltip.className = 'aviiro-shipping-note__tooltip';
    tooltip.id = infoId;
    tooltip.setAttribute('role', 'tooltip');
    tooltip.hidden = true;

    // Highlight the discount code (e.g. "AV26") within the tooltip copy,
    // without needing raw HTML in the translatable locale string — Liquid's
    // `| t` filter HTML-escapes its output, so any markup written directly
    // into locales/*.json would show up as literal escaped tags instead of
    // rendering. Splitting on the plain code text and wrapping it here in JS
    // sidesteps that entirely.
    var infoText = strings.freeShippingInfo || 'Free shipping to Saudi Arabia and the UAE.';
    var code = strings.discountCode || 'AV26';
    infoText.split(code).forEach(function (part, index) {
      if (index > 0) {
        var codeEl = document.createElement('strong');
        codeEl.className = 'aviiro-shipping-note__code';
        codeEl.textContent = code;
        tooltip.appendChild(codeEl);
      }
      if (part) tooltip.appendChild(document.createTextNode(part));
    });

    document.body.appendChild(tooltip);

    info.addEventListener('click', function (event) {
      event.stopPropagation();
      if (tooltip.hidden) {
        document.querySelectorAll('.aviiro-shipping-note__tooltip').forEach(function (other) {
          if (other !== tooltip) other.hidden = true;
        });
        tooltip.hidden = false;
        positionTooltip(tooltip, info);
        info.setAttribute('aria-expanded', 'true');
      } else {
        closeTooltip(tooltip, info);
      }
    });

    priceEl.insertAdjacentElement('afterend', wrap);
  }

  var TAG_ICON_SVG =
    '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" ' +
    'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M20.59 13.41 13 21l-9-9V3h9l9 9a2 2 0 0 1 0 1.41Z"/>' +
    '<circle cx="7.5" cy="7.5" r="1" fill="currentColor" stroke="none"/></svg>';

  function ensureDiscountBadge(priceEl) {
    if (priceEl.querySelector('.aviiro-discount-badge')) return;

    var strings = window.aviiroStrings || {};
    var percent = strings.discountPercent;
    if (!percent || percent <= 0 || !strings.discountBadgeText) return;

    var badge = document.createElement('span');
    badge.className = 'aviiro-discount-badge';
    badge.innerHTML = TAG_ICON_SVG;

    var label = document.createElement('span');
    label.textContent = strings.discountBadgeText;
    badge.appendChild(label);

    priceEl.appendChild(badge);
  }

  function ensureAll() {
    document
      .querySelectorAll('[id$="__main"] product-price, [id$="__featured_product_information_YBCLyR"] product-price')
      .forEach(function (priceEl) {
        // Product page opted out of the shipping note + info tooltip; still
        // shown on the featured-product section elsewhere (e.g. homepage).
        if (!priceEl.closest('[id$="__main"]')) {
          ensureNote(priceEl);
        }
        ensureDiscountBadge(priceEl);
      });
  }

  function closeAll() {
    document.querySelectorAll('.aviiro-shipping-note__tooltip').forEach(function (tooltip) {
      if (tooltip.hidden) return;
      var infoId = tooltip.id;
      var info = document.querySelector('[aria-controls="' + infoId + '"]');
      closeTooltip(tooltip, info || { setAttribute: function () {} });
    });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('.aviiro-shipping-note__info')) return;
    closeAll();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });

  window.addEventListener('scroll', closeAll, { passive: true });
  window.addEventListener('resize', closeAll);

  function init() {
    ensureAll();

    // Mirrors buy-it-now.js: Shopify can morph the price block on variant
    // change, which would drop our inserted note if we didn't watch for it.
    var observer = new MutationObserver(ensureAll);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
